import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Search, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useSearch } from '../context/SearchContext';
import { LanguageSelector } from './LanguageSelector';

export function FormToolbar() {
  const { t } = useTranslation('storefront');
  const { searchQuery, setSearchQuery } = useSearch();

  return (
    <div className="bg-card/80 sticky top-0 z-10 border-b px-4 py-2.5 backdrop-blur-sm">
      <div className="flex items-center justify-between gap-4">
        {/* Language Selector */}
        <div className="flex items-center gap-2">
          <LanguageSelector />
        </div>

        {/* Search Bar */}
        <div className="relative max-w-md flex-1">
          <Search className="text-muted-foreground pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2" />
          <Input
            type="text"
            placeholder={t('configEditor.toolbar.searchFields')}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="bg-background border-input focus:border-primary focus-visible:ring-primary h-9 pl-9 pr-9 transition-all"
          />
          {searchQuery && (
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setSearchQuery('')}
              className="hover:bg-destructive/10 hover:text-destructive absolute right-1 top-1/2 h-7 w-7 -translate-y-1/2 p-0 transition-colors"
            >
              <X className="h-3 w-3" />
            </Button>
          )}
        </div>
      </div>

      {/* Search Results Indicator */}
      {searchQuery && (
        <div className="mt-2.5 flex items-center gap-2">
          <div className="bg-primary/10 text-primary rounded-full px-2.5 py-1 text-xs font-medium">
            Filtering by: "{searchQuery}"
          </div>
          <button
            onClick={() => setSearchQuery('')}
            className="text-muted-foreground hover:text-foreground text-xs underline underline-offset-2 transition-colors"
          >
            Clear filter
          </button>
        </div>
      )}
    </div>
  );
}
